import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import { Button } from '@material-ui/core'
import ProductLibraryIcon from 'components/Workspace2ActionBar/ProductLibraryIcon'
import React from 'react'

interface ProductLibraryButtonProps {
    tooltipText: string
    iconFill?: string
    onClick: () => void
    buttonClassName?: string
}

export const ProductLibraryButton: React.FC<ProductLibraryButtonProps> = ({
    tooltipText,
    iconFill = '#314959',
    onClick,
    buttonClassName,
}) => (
    <HoverTooltip text={tooltipText}>
        <Button
            data-testid="product-library-button"
            onClick={onClick}
            className={buttonClassName}
            startIcon={<ProductLibraryIcon fill={iconFill} />}
            aria-label="Product Library"
        >
            Product Library
        </Button>
    </HoverTooltip>
)
